import { deriveBattleship } from './battleship.js';
import { deriveBeerPong } from './beerpong.js';
import { deriveCheckers } from './checkers.js';
import { deriveConnect4 } from './connect4.js';
import { deriveMancala } from './mancala.js';
import { derivePool } from './pool.js';
export function summarizeGameTurn(kind, moves, playerIds) {
    const moveCount = moves.length;
    switch (kind) {
        case 'pool': {
            // Pool keeps the turn on a legal pot; each move carries the shooter's outcome snapshot,
            // so whose turn it is is pure data (no physics engine needed here).
            const state = derivePool(moves, playerIds);
            const decided = state.winner !== null;
            return { turn: decided ? null : state.turn, decided, moveCount };
        }
        case 'beerpong': {
            const state = deriveBeerPong(moves, playerIds);
            const decided = state.winner !== null;
            return { turn: decided ? null : state.turn, decided, moveCount };
        }
        case 'battleship': {
            const state = deriveBattleship(moves, playerIds);
            const decided = state.winner !== null;
            return { turn: decided ? null : state.turn, decided, moveCount };
        }
        case 'mancala': {
            const state = deriveMancala(moves, playerIds);
            return {
                turn: state.turn,
                decided: state.winner !== null || state.isDraw,
                moveCount,
                quiet: state.lastSharedPhone,
            };
        }
        case 'checkers': {
            const state = deriveCheckers(moves, playerIds);
            return { turn: state.turn, decided: state.winner !== null || state.isDraw, moveCount };
        }
        case 'connect4': {
            const state = deriveConnect4(moves, playerIds);
            const decided = state.winner !== null || state.isDraw;
            return { turn: decided ? null : state.turn, decided, moveCount };
        }
    }
}
//# sourceMappingURL=summary.js.map